const ENDPOINTS = {
  // Google Places
  PLACES_AUTOCOMPLETE: '/api/places/autocomplete',
  PLACES_DETAILS: '/api/places/details',
  
 
};

export default ENDPOINTS;